import { useClassName } from '@/styles/JwVideoArticle';
import { Component, ComponentProps } from '@/types/component';
import { mergeProps } from '@/utils/mergeProps';
import { stripHtml } from '@/utils/stripHtml';
import { useJWPlayer } from './JWPlayerContext';

export interface VideoArticleHeaderTitleProps extends ComponentProps<'span'> {
  mediaId?: string;
}

export const VideoArticleHeaderTitleComponent: Component<VideoArticleHeaderTitleProps> = ({
  mediaId,
  children,
  ...props
}) => {
  const className = useClassName('header_title', props);

  const { currentMedia } = useJWPlayer();

  const videoHasChanged = currentMedia?.mediaid && currentMedia?.mediaid !== mediaId;
  const videoTitle = stripHtml(currentMedia?.title);

  return <h2 {...mergeProps({ className }, props)}>{videoHasChanged ? videoTitle : children}</h2>;
};
